import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { catchError, map, Observable, of, shareReplay, Subject, throwError } from 'rxjs';
import { AnySoaRecord } from 'dns';
import { saveMedicationDTO } from '../client/Templates/manage-medications/manage-medications.component';
import { string } from 'prop-types';
import { VitalHttpServices } from '../core/services/VitalHttpServices';
import { MatSnackBar } from '@angular/material/snack-bar';
import { associatedAccounts } from './components/share/model/usermodels';
import {
  ICD_CODE_LIBRARY_DUMMY_ROOTS,
  IcdCodeLibraryApiTreeNode
} from './icd-code-library-dummy.data';

@Injectable({
  providedIn: 'root'
})

export class LabadminService {

  sourceApp: string = "";
  menuList = []
  secondaryMenuList = []
  redirectToSecondaryMenu = '';
  isSubTabEnabled: boolean = false;
  public testTabData: any;
  public baseUrl2 = environment.baseUrl2;
  selectedSubmenu = {}
  selectedSecondarySubmenu = {}
  rbacPermissions = {}
  subMenuPermissions: any;
  organizationId: string = '';
  accountId: string = '';
  labadminLoggedinUser: string = '';
  labadminLoggedinUserEmail: string = '';
  deploymentKey: string = '';
  templateData: any = {};
  detailsData: any = {};
  subSideMenu = []
  redirectToMenu: string = ''
  /** When true, subsidemenu shows a confirm dialog before navigating (set from template-wrapper when not on list page). */
  blockSubmenuNavigation = false
  hidCMSCATURl1 = environment.hidCMSCATURl1;
  // public baseUrl2 = environment.baseUrl2;
  hidCMSCATCSKTKN = environment.hidCMSCATCSKTKN;
  formattedDisplayName: string = '';
  refreshGlobalSearchGrid = new Subject<any>();
  emitRefreshGrid: any = this.refreshGlobalSearchGrid.asObservable();
  fromGlobalSearch: boolean = false;
  selectedDropdown: any;
  showSidebarMenu = new Subject<any>();
  showSidebarMenu$: any = this.showSidebarMenu.asObservable();
  associatedAccountIds: string;
  associatedAccounts: any[] = [];
  domainUrl: any = ''
  clientOrgid: any
  showIntigrationLoader: boolean = false
  orgGuid: string = "";
  detailsCardSelected: any;
  isLaunchedInIframe: any;
  associatedAccountGuids: any;
  public importLabFlag = false;
  private subject = new Subject<any>();
  locationId: any;
  locationName: any;
  sendOutLocationUId: any;
  loginType: any;

  constructor(
    public httpClient: HttpClient,
    private _vitalHttpServices: VitalHttpServices,
    private _snackbar: MatSnackBar,
  ) {
  }

  setTabData(data: any) {
    this.subject.next({ data: data });
  }

  getTabData(): Observable<any> {
    return this.subject.asObservable();
  }

  getUserRoles(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/getuserinformation`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  getContentMgmtData(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/masterdata/getcontentmanagementdata`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  // lab user card list
  getLabUserDetails(orgId, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/GetLabUserDetails`, orgId, { params: { 'Conn': dbName } });
  }

  // lab user card list
  getFrozenLabUserDetails(orgId, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/GetUsersListForFrozen`, orgId, { params: { 'Conn': dbName } });
  }

  // client user card list
  getClientUserDetails(orgId, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/GetClientsDetails`, orgId, { params: { 'Conn': dbName } });
  }

  saveUpdateImportLabs(Obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/saveUpdateImportLabs`, Obj, { params: { 'Conn': dbName } });
  }


  getPdfFile(PDFid) {
    return this.httpClient.get<any>(
      `${this.hidCMSCATURl1}/assets/${PDFid.id}?access_token=${this.hidCMSCATCSKTKN}`
    );
  }
  getProfileInformation(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/getprofileinformation`,
      obj, { params: { 'Conn': dbName } }
    );
  }

  getProfileInformationMasterData(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/masterdata/profilemasterdata`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  getSecurityQuestionsList(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/masterdata/getorganizationattributes`,
      obj, { params: { 'Conn': dbName } }
    );
  }

  /**
   * Master data for library picker dropdowns (e.g. RaceMaster, EthnicityMaster).
   * GET api/masterdata/get?tableName={tableName}&Conn={dbName}&searchText={searchText}
   */
  getMasterDataByTableName(tableName: string,dbName: string = 'configdb',searchText?: string): Observable<any> {
    const masterTable = (tableName ?? '').trim();
    const conn = (dbName ?? 'configdb').trim() || 'configdb';
    if (!masterTable) {
      return of(null);
    }
    const params: Record<string, string> = { Conn: conn, tableName: masterTable };
    const search = (searchText ?? '').trim();
    if (search) {
      params.searchText = search;
    }
    return this.httpClient.get<any>(`${this.baseUrl2}api/masterdata/get`, {
      params
    }).pipe(map(res => res?.body ?? res),
      catchError(err => {
        console.error('getMasterDataByTableName failed', masterTable, err);
        throw err;
      })
    );
  }

  getSecurityQuestions(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/getcustomsecurityquestions`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  saveSecurityQuestions(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/savesecurityquestions`,
      obj, { params: { 'Conn': dbName } }
    );
  }

  saveProfileInfo(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/saveprofileinformation`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  changePassword(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/passwordchange`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  sendMigrateInvitation(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/updateisemailIdverified`,
      obj, { params: { 'Conn': dbName } }
    );
  }
  verify(obj, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/requestmailtousers`,
      obj, { params: { 'Conn': dbName } }
    );
  }

  getDepartments(dbName) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/labadmin/OrganizationDepartments`, { params: { 'Conn': dbName } })
  }


  // UpdateLockUnlock  lab user
  UpdateLockUnlockUser(commonkey, status, modifiedBy, dbName) {
    let userDetails = {
      commonkey: commonkey,
      isAccountLockedOut: status,
      modifiedBy: modifiedBy
    }
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/UpdateLockUnlockUser`, userDetails, { params: { 'Conn': dbName } });
  }

  GetIsMedicalDirectorExists(OrganizationId, UserId, dbName) {
    return this.httpClient.get<string>(
      `${this.baseUrl2}api/isMedicalDirectorExists?OrganizationId=` +
      OrganizationId + '&UserId=' + UserId, { params: { 'Conn': dbName } });
  }

  getRoles(orgID: any, Lab: any, dbName: string, fromType = null) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Roles?orgID=` + orgID + '&forLab=' + Lab + '&FromType=' + fromType, { params: { 'Conn': dbName } });
  };

  getValueFromLookup(contextID: any, lookuptype: any, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=`
      + contextID + '&lookuptype=' + lookuptype, { params: { 'Conn': dbName } });
  };

  getStateAndCity(zipCode: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/GetCityAndStateFormZipCode?ZipCode=` + zipCode, { params: { 'Conn': dbName } });
  }

  getSharedSurgiCenterForOF(accountID: any, labaccountID: any, oper: any, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/SharedSurgiCenterForOF?accountID=${accountID}&labaccountID=${labaccountID}&oper=${oper}`, { params: { 'Conn': dbName } })
  }

  npiValidate(organizationid: number, APIEndPoint: string, searchParms: { City: string, FirstName: string, LastName: string, NPI: string, OrganizationName: string, State: string, Taxonomy: string, Zip: string }, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/NPIDetailsForValidate/${organizationid}?APIEndPoint=${APIEndPoint}`, searchParms, { params: { 'Conn': dbName } })
  }

  // check duplicate npi
  checkNPIExists(npidata, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/user/CheckNPIExists`, npidata, { params: { 'Conn': dbName } });
  }

  getSalesExecutiveAndCourierData(orgId: number, ofAccId: number, labAccountIDList: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/SalesExecutiveUsers?labAccountIDList=${labAccountIDList}&oFAccID=${ofAccId}&organizationID=${orgId}`, { params: { 'Conn': dbName } })
  }

  getAttachmentsAndNotes(userId: string, accountid: string, loggedInUserId: string, oper: number, dbName: string) {
    const url = `${this.baseUrl2}api/attachments/all/${userId}?accountId=${accountid}&loggedInUserId=${loggedInUserId}&oper=${oper}`
    return this.httpClient.get<any>(url, { params: { 'Conn': dbName } })
  }

  uploadSuplements(uploadedAttachment: any, dbName: string) {
    const url = `${this.baseUrl2}api/attachments/upload`
    return this.httpClient.post(url, uploadedAttachment, { params: { 'Conn': dbName } })
  }

  ViewSupplements(fileId: string, dbName: string) {
    const url = `${this.baseUrl2}api/attachments/view?fileId=${fileId}`
    return this.httpClient.get(url, { params: { 'Conn': dbName }, responseType: 'blob' })
  }

  deleteSupplements(fileId: string, caseId: string | null, dbName: string) {
    const url = `${this.baseUrl2}api/attachments/Delete/${fileId}?caseId=${caseId}`;
    return this.httpClient.post(url, fileId, { params: { 'Conn': dbName } })
  }

  saveAndUpdateAccount(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/Location/SaveLocation`, data, { params: { 'Conn': dbName } })
  }

  saveAndUpdateSendOutAccount(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/Location/SaveSendoutLocation`, data, { params: { 'Conn': dbName } })
  }

  saveAndUpdateNewPractice(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/Location/Practice`, data, { params: { 'Conn': dbName } })
  }

  /** Same endpoint as create-reading-location: api/readingLocation/ManageReadingLocation */
  saveReadingLocation(obj: any, dbName: string) {
    return this._vitalHttpServices.saveReadingLocation(obj, dbName);
  }

  isExists(strName: string, iOper: number, id: number, orgid: string = '', usertype: string = "", dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/IsExists?strName=${strName}&iOper=${iOper}&id=${id}&orgid=${orgid}&usertype=${usertype}`, { params: { 'Conn': dbName } })
  }
  organizationDetails(orgId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/OrganizationDetails?orgID=${orgId}`, { params: { 'Conn': dbName } })
  }

  GetVARulesSearchDetails(ruleName: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/VARulesDetails?SearchValue=${ruleName}`, { params: { 'Conn': dbName } })
  }

  InsertVARulesExclusions(ModiftId: number, data: any, dbName: string) {
    const url = `${this.baseUrl2}api/InsertVARulesExclusions?ModifiedBy=${ModiftId}`
    return this.httpClient.post<any>(url, (data), { params: { 'Conn': dbName } });
  }

  ActivateDeactivateVARules(ruleID: number, status: number, ModifiedBy: number, dbName: string) {
    const url = `${this.baseUrl2}api/ActivateDeactivateVARules?ruleID=${ruleID}&status=${status}&ModifiedBy=${ModifiedBy}`;
    return this.httpClient.post(url, null, { params: { 'Conn': dbName } });
  }

  physicianDataForFaxandPrinting(accountId: number, userId: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/OrderingPhysician?OFActID=${accountId}&loggedInUserid=${userId}`, { params: { 'Conn': dbName } })
  }
  createRuleId(objVARule: any, dbName: string) {
    const url = `${this.baseUrl2}api/InsertVARulesDetails`
    return this.httpClient.post<any>(url, (objVARule), { params: { 'Conn': dbName } });
  }

  InsertVARulesExclusionsForEmail(objVARule: any, dbName: string) {
    const url = `${this.baseUrl2}api/InsertVARulesForEmailDistribution`
    return this.httpClient.post<any>(url, (objVARule), { params: { 'Conn': dbName } });
  }

  InsertVaIntRecipient(vaIntRecipientnDTO: any, dbName: string) {
    const url = `${this.baseUrl2}api/InsertVaIntRecipient`
    return this.httpClient.post<any>(url, (vaIntRecipientnDTO), { params: { 'Conn': dbName } });
  }

  GetIsPcEnabled(loggedinuseraaccountid: string, accountid: string, OrganizationID: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/IsPcEnabled?loggedinuseraaccountid=${loggedinuseraaccountid}&accountid=${accountid}&OrganizationID=${OrganizationID}`, { params: { 'Conn': dbName } })
  }
  SaveCustomerAttribute(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/Location/CustomAttributes`, data, { params: { 'Conn': dbName } })
  }
  DeleteVaRulesExclusions(ruleID: number, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/DeleteVaRulesExclusions?ruleID=${ruleID}`, ruleID, { params: { 'Conn': dbName } })
  }

  getLabLocations(LabGroupID, userid, AccountId, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/LabLocations?LabGroupID=${LabGroupID}&userid=${userid}&AccountId=${AccountId}`, { params: { 'Conn': dbName } })

  }
  getCaseCategoryByAccId(accountId, orgId, labAccountIds, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/CaseTypesbyActId?actID=${accountId}&orgID=${orgId}&labActIDs=${labAccountIds}`, { params: { 'Conn': dbName } })
  }
  getLabLocationsCasetype(LabGroupID: string, userid: string, AccountId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/LabLocationsCasetype?LabGroupID=${LabGroupID}&userid=${userid}&AccountId=${AccountId}`, { params: { 'Conn': dbName } })
  }
  getReadingRemoteAndLabLocation(organizationId: string, dbName: string) {
    return this.httpClient.get<any>(
      `${this.baseUrl2}api/Location/GetReadingRemoteAndLabLocation?organizationId=${organizationId}`,
      { params: { 'Conn': dbName } }
    )
  }
  getLocationDetails(accountId: number, userOrgId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/GetAccount?accountID=${accountId}&UserOrgID=${userOrgId}`, { params: { 'Conn': dbName } })
  }
  getPhysicinData(accountID: number, userID: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/PhysicianData?accountID=${accountID}&userID=${userID}`, { params: { 'Conn': dbName } })
  }
  CustomOrgValues(LabOrgID: number, Orgid: number, entityId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/CustomOrgValues?LabOrgID=${LabOrgID}&EntityID=${Orgid}&EntityType=${entityId}`, { params: { 'Conn': dbName } })
  }
  GetServices(accountId: number, iOper: number, UserId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Services?Id=${accountId}&iOper=${iOper}&UserId=${UserId}`, { params: { 'Conn': dbName } })
  }

  getOFAssociationForSE(accountIds: string, salesExecutiveUserId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/OFAssociationForSE?accountIds=${accountIds}&SalesExecutiveUserId=${salesExecutiveUserId}`, { params: { 'Conn': dbName } })
  }

  getPathList(OrganizationID: string, ExecutiveUserId: string, iOFAccountID: string, loggedInUserid: string, Type: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}/api/users/AssociationsByRole?OrganizationID=${OrganizationID}&ExecutiveUserId=${ExecutiveUserId}&iOFAccountID=${iOFAccountID}&loggedInUserid=${loggedInUserid}&Type=${Type}`, { params: { 'Conn': dbName } })
  }

  generatePassword(loginId: string, modifiedby: string, dbName: string) {
    return this.httpClient.get<string>(
      `${this.baseUrl2}api/user/resetpassword?loginid=` + loginId + '&ModifiedBy=' + modifiedby,
      { params: { 'Conn': dbName } }
    );
  }

  migrateUser(requestData: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/user/UserMigration`, requestData, { params: { 'Conn': dbName } });
  }

  // to send a password link
  sendResetPwdLink(data) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/user/resetpasswordlink`, data)
  }

  getUserProfile(userId: string, dbName, getPrimary: boolean = false) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/Users?userid=${userId}&getPrimary=${getPrimary}`, { params: { 'Conn': dbName } })
  }

  getsaveRoles(userId: string, dbName) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/SavedRoles?userID=${userId}`, { params: { 'Conn': dbName } })
  }

  getAddSettings(labOrgId: string, accountid: string, entitytype: string, dbName) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/CustomOrgValues?LabOrgID=${labOrgId}&EntityID=${accountid}&EntityType=${entitytype}`, { params: { 'Conn': dbName } })
  }
  getGlobalSearchDetails(searchData: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/labadmin/GlobalSearchResults`, searchData, { params: { 'Conn': dbName } })
  }

  getAssociationsByRole(OrganizationID: string, ExecutiveUserId: number = 0, iOFAccountID: string, loggedInUserid: string, Type: string = 'pathologist', dbName: string = "LIS") {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/AssociationsByRole?OrganizationID=${OrganizationID}&ExecutiveUserId=${ExecutiveUserId}&iOFAccountID=${iOFAccountID}&loggedInUserid=${loggedInUserid}&Type=${Type}`, { params: { 'Conn': dbName } })
  }
  SaveUsers(userData: any, pathReadingLocation: number, LoggedInUserOrgID: string, EnableUserAssociation: string, EnableProviderMDM: boolean, dbName: string, from: string = 'ofusers') {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/users/SaveUsers?pathReadingLocation=${pathReadingLocation}&LoggedInUserOrgID=${LoggedInUserOrgID}&EnableUserAssociation=${EnableUserAssociation}&EnableProviderMDM=${EnableProviderMDM}&from=${from}`, userData, { params: { 'Conn': dbName } })
  }
  GetUserDetails(userid: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/Users?userid=${userid}`, { params: { 'Conn': dbName } })
  }
  GetsavedRoleList(userID: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/SavedRoles?userID=${userID}`, { params: { 'Conn': dbName } })
  }
  GetLocationList(OrganizationID: number, loggedInUserID: number, userID: number, type: string, _UserID: number = 0, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/LocationList?OrganizationID=${OrganizationID}&loggedInUserID=${loggedInUserID}&userID=${userID}&type=${type}&_UserID=${_UserID}`, { params: { 'Conn': dbName } })
  }

  GetVAruleExclusionDetails(ruleID: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/VaruleExclusionDetails?ruleID=${ruleID}`, { params: { 'Conn': dbName } })
  }
  GetVAExtAttrValue(EntityID: string, ExtAttrName: string, ExtAttrType: string, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/VAExtAttr?EntityID=${EntityID}&ExtAttrName=${ExtAttrName}&ExtAttrType=${ExtAttrType}`, { params: { 'Conn': dbName }, responseType: 'text' })
  }

  // npi tab api integration
  // npiDetails(dbName: string, LoggedInUserOrgID: string,data:any) {
  //   return this.httpClient.post<any>(`${this.baseUrl2}/api/NPIDetailsForValidate/${LoggedInUserOrgID}/?APIEndPoint=SearchUser`,data, { params: { 'Conn': dbName } })
  // }

  // locationNpiDetails(dbName: string, LoggedInUserOrgID: string,data:any){
  //   return this.httpClient.post<any>(`${this.baseUrl2}/api/NPIDetailsForValidate/${LoggedInUserOrgID}/?APIEndPoint=SearchLocation`,data, { params: { 'Conn': dbName } })
  // }

  GetSampleTemplates(type: 'users' | 'labusers', dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/bulkupload/templates/${type}`, { params: { 'Conn': dbName }, responseType: 'blob' })
  }

  ValidateUploadedData(type: 'users' | 'labusers', uploadData: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/bulkupload/validate/${type}`, uploadData, { params: { 'Conn': dbName } })
  }

  saveUploadedUsers(type: 'users' | 'labusers', uplodedData: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/bulkupload/upload/${type}`, uplodedData, { params: { 'Conn': dbName } })
  }

  GetSharedSurgiAccountsData(userID: string, loggedInUserID: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/SharedSurgiForPhysician?userID=${userID}&loggedInUserID=${loggedInUserID}`, { params: { 'Conn': dbName } })
  }
  GetAccountsByUserid(iUserID: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/AccountsByUserid?iUserID=${iUserID}`, { params: { 'Conn': dbName } })
  }
  GetFrozenAccounts(iUserID: number, OrgID: number, dbName: string, Type: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/GetFrozenAccountsByid?iUserID=${iUserID}&OrgID=${OrgID}&Type=${Type}`, { params: { 'Conn': dbName } })
  }

  UpdateAccountStatus(accountid: number, status: string, loggedInUserPrimaryAccountId: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/updateaccountstatus?accountId=${accountid}&status=${status}&loggedInUserPrimaryAccountId=${loggedInUserPrimaryAccountId}`, { params: { 'Conn': dbName } });
  }
  FaxandPrinting(obj, dbName) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/getfaxdetails/faxdetails`, obj, { params: { 'Conn': dbName } });
  }

  isPathologistPrivilagePresent(OrganizationId: string, UserId: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/isPathPrivilageExists?OrganizationId=${OrganizationId}&UserId=${UserId}`, { params: { 'Conn': dbName } })
  }

  ActiveInActiveDeleteUsers(userDetails: any, loggedInUserOrgId: number, dbName: string, isPhysician: boolean = false) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/users/ActiveInActiveUsers?loggedInUserOrgId=${loggedInUserOrgId}&isPhysician=${isPhysician}`, userDetails, { params: { 'Conn': dbName } })
  }

  getEncrptectURL(locationId: string, physicianId: string, patientPortalUrl: string, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/Location/GetEncriptedURL?PhysicianId=${physicianId}&LocationId=${locationId}&PatientPortalURL=${patientPortalUrl}`, { params: { 'Conn': dbName }, responseType: 'text' as const })

  }
  getIsSharedSurgicenter(OrganizationId: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/IsSharedSurgicenter?OrganizationID=${OrganizationId}`, { params: { 'Conn': dbName } })
  }

  isExistsWithValue(strName: string, iOper: number, id: number, orgid: string = '', dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/Location/IsExistsInDBWithValue?strName=${strName}&iOper=${iOper}&id=${id}&orgid=${orgid}`, { params: { 'Conn': dbName }, responseType: 'text' })
  }

  removeLogo(accountid: number, userid: string, dbName: string, organizationId: number = 0, from: string = '') {
    const url = `${this.baseUrl2}api/Location/RemoveLogo?organizationId=${organizationId}&accountid=${accountid}&from=${from}&userid=${userid}`
    return this.httpClient.post(url, {}, { params: { 'Conn': dbName } })
  }

  RequestMailToSupport(EmailDetails: any, dbName: string,) {
    const url = `${this.baseUrl2}api/Location/RequestMailToSupport`
    return this.httpClient.post(url, EmailDetails, { params: { 'Conn': dbName } })
  }
  getEncryptedValue(object: {}) {
    return this.httpClient.post(`${this.baseUrl2}api/Location/GetEncryptedValues`, object)
  }
  getMedicationList(OrganizationId: Number, AccountId: Number, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/managemedications/GetMedicationList?OrganizationId=${OrganizationId}&AccountId=${AccountId}`, { params: { 'Conn': dbName } })
  }

  addAndUpdateMedication(dataObj: saveMedicationDTO, type: "update" | "", dbName: string) {
    return this.httpClient.post(`${this.baseUrl2}api/managemedications/SaveMedication?Type=${type}`, dataObj, { params: { 'Conn': dbName } })
  }

  AddEditDelObservationAndQuantitationTemplate(object: any, iOper: string, loggedinUserID: number, dbName: string) {
    return this.httpClient.post(`${this.baseUrl2}api/AddEditDelObservationAndQuantitationTemplate?iOper=${iOper}&loggedinUserID=${loggedinUserID}`, object, { params: { 'Conn': dbName } })
  }

  AddEditDelClinicalInfoTemplate(object: any, iOper: string, loggedinUserID: number, dbName: string) {
    return this.httpClient.post(`${this.baseUrl2}api/AddEditDelTemplate?iOper=${iOper}&loggedinUserID=${loggedinUserID}`, object, { params: { 'Conn': dbName }, responseType: 'text' })
  }
  GetUserDetailsForApproveResetPassword(userid: string, requestId: string, search: boolean, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/users/requestDetails?UserID=${userid}&RequestID=${requestId}&search=${search}`, { params: { 'Conn': dbName } })
  }

  approveOrDenyPassword(approvePasswordFor: any, dbName: string) {
    return this.httpClient.post(`${this.baseUrl2}api/users/approveOrDenyPassword`, approvePasswordFor, { params: { 'Conn': dbName } })
  }

  getAllowAndAutoRegisterDomains(OrganizationGUID: string, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/AllowAndAutoRegisterDomains?OrganizationGUID=${OrganizationGUID}`, { params: { 'Conn': dbName } })
  }
  getTemplateOrganizations(OrganizationId: string, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/Location/GetTemplateOrganizations?organizationdIDs=${OrganizationId}`, { params: { 'Conn': dbName } })
  }
  getCasetypeOnTemplates(accountId: string, userId: number | null, templateName: string, dbName: string) {
    return this.httpClient.get(`${this.baseUrl2}api/GetTemplateCastypes?AccountId=${accountId}&UserId=${userId}&TemplateName=${templateName}`, { params: { 'Conn': dbName } })
  }
  /// COMMONLY USED API
  private _states$: Observable<any> | null = null
  private _titles$: Observable<any> | null = null
  private _formattedDisplayNames$: Observable<any> | null = null
  private _computeOnValues$: Observable<any> | null = null
  private _thresholdValues$: Observable<any> | null = null
  getStates(dbName) {
    if (!this._states$) {
      this._states$ = this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=state code&lookuptype=PathologistLicensure`, { params: { 'Conn': dbName } }).pipe(
        shareReplay(1)
      );

    }
    return this._states$
  }
  getTitles(dbName) {
    if (!this._titles$)
      this._titles$ = this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=&lookuptype=title`, { params: { 'Conn': dbName } }).pipe(
        shareReplay(1)
      );
    return this._titles$
  }
  getFormattedDisplayNames(dbName) {
    if (!this._formattedDisplayNames$) {
      this._formattedDisplayNames$ = this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=Format&lookuptype=Name Format String`, { params: { 'Conn': dbName } }).pipe(
        shareReplay(1)
      );
    }
    return this._formattedDisplayNames$
  }
  getComputeOnValues(dbName) {
    if (!this._computeOnValues$) {
      this._computeOnValues$ = this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=ComputeOn&lookuptype=ComputeOn`, { params: { 'Conn': dbName } }).pipe(
        shareReplay(1)
      );
    }
    return this._computeOnValues$
  }
  getThresholdDurationValues(dbName) {
    if (!this._thresholdValues$) {
      this._thresholdValues$ = this.httpClient.get<any>(`${this.baseUrl2}api/States?contextID=ThresholdDuration&lookuptype=ThresholdDuration`, { params: { 'Conn': dbName } }).pipe(
        shareReplay(1)
      );
    }
    return this._thresholdValues$
  }

  UpdateStatus(StatusDetails: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/Location/UpdateOrganizationStatus`, StatusDetails, { params: { 'Conn': dbName } });
  }
  getReportBuilderPayload(dbName: string, orgID: string, clientIP: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/reportbuilder/getpayload`, { params: { 'Conn': dbName, 'orgID': orgID, 'clientIP': clientIP } },);
  };
  getIPAddress() {
    return this.httpClient.get(environment.IPAddressURL);
  };
  EncryptUrlPayload(dataArray) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/URLLaunch/Encrypt`, dataArray);
  }
  saveLotDetails(lotDetails: any, dbName: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/managelots/savelotDetails`, lotDetails, { params: { 'Conn': dbName }, responseType: 'text' as 'json' });
  }

  GetAssociatedTests(dbName: string, orgID: number, OrderCodeID: number | string, level: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/managelots/GetAssociatedTests?OrganizatioID=${orgID}&OrderCodeID=${OrderCodeID}&level=${level}`, { params: { 'Conn': dbName } },);
  };


  GetPanels(dbName: string, labacountId: number, CaseType: string, isqc: boolean = false, testCategory: string = null) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/managelots/GetPanel?labAccountID=${labacountId}&caseType=${CaseType}&isqc=${isqc}&testCategory=${testCategory}`, { params: { 'Conn': dbName } },);
  };
  GetLotDetails(dbName: string, LotId: number, OrganizationID: number) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/managelots/GetLotDetails?LotID=${LotId}&OrganizatioID=${OrganizationID}`, { params: { 'Conn': dbName } },);
  };
  DeleteLotDetails(dbName: string, LotId: number, ModifiedBy: number, organizationId: number, caseType: string) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/managelots/DeleteLotDetails?LotID=${LotId}&ModifiedBy=${ModifiedBy}&organizationId=${organizationId}&caseType=${caseType}`, null, { params: { 'Conn': dbName } });

  }

  generateXlTemplate(getTemplateObj: any) {
    return this.httpClient.post(`${this.baseUrl2}api/managelots/generateXlTemplate`, getTemplateObj, { params: { 'Conn': this.deploymentKey }, responseType: 'blob' });
  };

  validateLotData(lotData: any) {
    return this.httpClient.post<any>(`${this.baseUrl2}api/managelots/ValidateLot`, lotData, { params: { 'Conn': this.deploymentKey } });
  }
  IsLotNumberExists(OrganizatioID: number, LotNumber: string, dbName: string, lotId: number) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/managelots/IsLotnoExists?OrganizatioID=${OrganizatioID}&LotNumber=${LotNumber}&lotId=${lotId}`, { params: { 'Conn': dbName } });
  }

  removeDetailsCardSelected() {
    return this.detailsCardSelected ? this.detailsCardSelected = null : null;
  }

  // display name based on the Enable.Address.Allfacilities flag
  flagConfig(organizationID: any = null, depKey: any = null): Observable<boolean> {
    const orgId = organizationID ? organizationID : this.organizationId;
    const deploymentKey = depKey ? depKey : this.deploymentKey;

    if (!orgId || !deploymentKey) {
      // this._snackbar.open("Missing session data. Please log in again.", "Error");
      this._snackbar?.open("Missing session data. Please log in again.", null, {
        panelClass: ['failure-snackbar']
      });
      return of(false);
    }

    const queryVariable = { "orgid": orgId.toString(), "extrname": "Enable.Address.Allfacilities" };
    const query = this.GetQuery('getentityextattributesFlag');
    const queryResult = this.GetCardRequest(queryVariable, query);

    return this._vitalHttpServices.GetData(queryResult, deploymentKey).pipe(
      map(response => {
        const val = response?.data?.submenuData?.[0]?.ExtAttrValue == 'true' ? true : false;
        return val;
      },
        error => {
          console.error(error);
          return of(false);
        }))
  }

  GetCardRequest(queryVariable: any, query: string) {
    return this.GetQueryResult(queryVariable, query);
  }

  GetQueryResult(queryVariable: any, query: string) {
    let cancellationToken: any = {
      'IsCancellationRequested': false,
      'CanBeCancelled': true
    };
    let queryRequest: any = {
      "OperationName": null,
      "Query": query,
      "Variables": queryVariable
    };
    return queryRequest;
  }

  public GetQuery(keyword: string) {
    let query: string = '';
    let mainQueryIndex: number = this._vitalHttpServices.mainQueryList.findIndex(
      mainQuery =>
        mainQuery?.Keyword?.toLowerCase() == keyword?.toLowerCase()
    );
    if (mainQueryIndex > -1)
      query = this._vitalHttpServices.mainQueryList[mainQueryIndex].Query;
    return query;
  }

  GetUserRolePreferences(userid: number, dbName: string, orgtype: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/users/userpreferencesconfiguration?iUserID=${userid}&OrgType=${orgtype}`, { params: { 'Conn': dbName } })
  }

  getPriorityLevel(priority: string): string {
    return priority?.split('|')[0] || '';
  }

  getPriorityColorClass(priority: string): string {
    const color = priority?.split('|')[1]?.toLowerCase()?.trim();
    const colorMap: { [key: string]: string } = {
      'orange': 'bg-orange',
      'red': 'bg-red',
      'green': 'bg-green',
      'blue': 'bg-blue',
      'yellow': 'bg-yellow',
      'gray': 'bg-gray',
      'grey': 'bg-gray',
      'white': 'bg-white'
    };
    return colorMap[color || ''] || 'bg-gray';
  }

  getPriorityValues(organizationId: number) {
    let obj = {
      "organizationid": organizationId,
      "attributetype": [
        "Case Priority"
      ],
      "tablename": "OrganizationAttributes"
    };
    return this._vitalHttpServices.getOrganizationAttributes(obj, this.deploymentKey).pipe(
      map((data: any) => {
        if (data?.Message) {
          let dataConfig = JSON.parse(data?.Message);
          let finalObj = dataConfig
            ?.filter((item: any) => item.Attribute_Name !== "-- Select --")
            .map((item: any) => ({
              key: item.Attribute_Name,
              value: item.Attribute_Name + "|" + item.Attribute_Context
            }));
          return finalObj || [];
        } else {
          return [];
        }
      })
    );
  }

  getBillToValues(organizationId: number) {
    let obj = {
      "organizationid": organizationId,
      "attributetype": [
        "BillTo"
      ],
      "tablename": "OrganizationAttributes"
    };
    return this._vitalHttpServices.getOrganizationAttributes(obj, this.deploymentKey).pipe(
      map((data: any) => {
        if (data?.Message) {
          let dataConfig = JSON.parse(data?.Message);
          let finalObj = dataConfig
            ?.filter((item: any) => item.Attribute_Name !== "-- Select --")
            .map((item: any) => ({
              key: item.Attribute_Name,
              value: item.Attribute_Name
            }));
          return finalObj || [];
        } else {
          return [];
        }
      })
    );
  }

  getOrganizationAttributesByType(organizationId: number, attributeType: string[], casetype: string = '', tablename: string = 'OrganizationAttributes') {
    let obj = {
      "organizationid": organizationId,
      "attributetype": attributeType,
      "casetype": casetype,
      "tablename": tablename
    };
    return this._vitalHttpServices.getOrganizationAttributes(obj, this.deploymentKey);
  }

  IsLotNameExists(OrganizatioID: number, LotName: string, dbName: string, lotId: number) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/managelots/IsLotNameExists?OrganizatioID=${OrganizatioID}&LotName=${LotName}&lotId=${lotId}`, { params: { 'Conn': dbName } });
  }

  getClientSendOutDetails(orgId, dbName) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/GetSendoutDetails`, orgId, { params: { 'Conn': dbName } });
  }

  sendOutOrganizationDetails(orgId: number, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/OrganizationDetails?orgID=${orgId}`, { params: { 'Conn': dbName } })
  }

  getSendOutLocationDetails(accountId: number, userOrgId: number, dbName: string, labType: string = '') {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/GetSendoutAccount?accountID=${accountId}&UserOrgID=${userOrgId}&LabType=${labType}`, { params: { 'Conn': dbName } })
  }

  saveAndUpdateSendoutNewPractice(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/Location/SendOutPractice`, data, { params: { 'Conn': dbName } })
  }

  getSendOutLabLocations(LabGroupID, userid, AccountId, dbName: string, labType: string = '') {
    return this.httpClient.get<any>(`${this.baseUrl2}api/Location/SendOutLabLocations?LabGroupID=${LabGroupID}&userid=${userid}&AccountId=${AccountId}&LabType=${labType}`, { params: { 'Conn': dbName } })
  }

  addOrgIcdCodes(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/icdcodes/Add`, data, { params: { 'Conn': dbName } })
  }

  getOrgLevelIcdCodes(organizationId: number, searchText: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/geticdcodeslabadmin?organizationId=${organizationId}&searchText=${searchText}`, { params: { 'Conn': dbName } })
  }

  addTestLevelIcdCodes(data: any, dbName: string) {
    return this.httpClient.post<any>(
      `${this.baseUrl2}api/labadmin/testlevel/icdcodes/Add`, data, { params: { 'Conn': dbName } })
  }

  getTestLevelIcdCodes(organizationId: any, casetype: string, dbName: string) {
    return this.httpClient.get<any>(`${this.baseUrl2}api/gettestlevelicdcodeslabadmin?OrganizationId=${organizationId}&CaseType=${casetype}`, { params: { 'Conn': dbName } })
  }
  /**
   * Dummy MDM ICD tree for add-library search. Call only when the user query is long enough (default 3+ chars).
   * Returns a pruned tree by code, name, alias, description; empty array if the query is too short or blank.
   * Does not mutate the source fixture.
   */
  getDummyIcdCodeLibraryRoots(searchText: string, minSearchChars: number = 3): IcdCodeLibraryApiTreeNode[] {
    const q = String(searchText ?? '').trim();
    if (!q || q.length < minSearchChars) {
      return [];
    }
    const searchLower = q.toLowerCase();
    return ICD_CODE_LIBRARY_DUMMY_ROOTS.map(r =>
      this.pruneIcdLibraryNodeForSearch(r, searchLower)
    ).filter((x): x is IcdCodeLibraryApiTreeNode => x != null);
  }

  private pruneIcdLibraryNodeForSearch(
    node: IcdCodeLibraryApiTreeNode,
    searchLower: string
  ): IcdCodeLibraryApiTreeNode | null {
    const matchesApiNode = (n: IcdCodeLibraryApiTreeNode): boolean => {
      const code = (n.ICDCode ?? '').toLowerCase();
      const name = (n.ICDCodeName ?? '').toLowerCase();
      const alias = (n.AliasName ?? '').toLowerCase();
      const desc = (n.ICDCodeDescription ?? '').toLowerCase();
      return (
        code.includes(searchLower) ||
        name.includes(searchLower) ||
        alias.includes(searchLower) ||
        desc.includes(searchLower)
      );
    };
    const prunedChildren = (node.children ?? [])
      .map(c => this.pruneIcdLibraryNodeForSearch(c, searchLower))
      .filter((x): x is IcdCodeLibraryApiTreeNode => x != null);
    if (matchesApiNode(node) || prunedChildren.length > 0) {
      return { ...node, children: prunedChildren };
    }
    return null;
  }

  searchIcdCodeLibrary(searchText: string, minSearchChars: number = 3): Observable<any> {
    const q = String(searchText ?? '').trim();
    if (!q || q.length < minSearchChars) {
      return of(null);
    }
    return this.getMasterDataByTableName('icdcodes', 'configdb', q);
  }

  // library components changes

  buildGraphqlRequest(variables: Record<string, string>, query: string): any {
    return this.GetQueryResult(variables, query);
  }

  resolveDeploymentKey(dbName?: string): string {
    return (dbName || this.deploymentKey || sessionStorage.getItem('deploymentKey') || '').toString();
  }

  executeDynamicMutation(req: DynamicMutationRequest): Observable<any> {
    const tableName = (req.tableName || '').trim();
    if (!tableName) {
      return throwError(() => new Error('tableName is required'));
    }

    const queryKey =
      req.operationType === 'insert'
        ? (req.insertQueryKey || 'InsertDynamic')
        : (req.updateQueryKey || 'UpdateDynamic');

    const query = this.GetQuery(queryKey);
    if (!query?.trim()) {
      return throwError(() => new Error(`GraphQL query not found for keyword: ${queryKey}`));
    }

    if (req.operationType === 'update') {
      if (!(req.whereField || '').trim()) {
        return throwError(() => new Error('whereField is required for update'));
      }
      if (req.whereValue == null || String(req.whereValue).trim() === '') {
        return throwError(() => new Error('whereValue is required for update'));
      }
    }

    const variables: Record<string, string> = {
      operationType: req.operationType,
      tableName,
      data: JSON.stringify(req.data ?? {}),
      uniqueData: JSON.stringify(req.uniqueData ?? {}),
      filterData: JSON.stringify(req.filterData ?? {})
    };

    if (req.operationType === 'insert') {
      if (req.sequenceColumnNames != null) {
        variables.sequenceColumnNames =
          typeof req.sequenceColumnNames === 'string'
            ? req.sequenceColumnNames
            : JSON.stringify(req.sequenceColumnNames);
      }
      if (req.sequenceFilterData != null) {
        variables.sequenceFilterData =
          typeof req.sequenceFilterData === 'string'
            ? req.sequenceFilterData
            : JSON.stringify(req.sequenceFilterData);
      }
    } else if (req.sequenceFilterData != null) {
      variables.sequenceFilterData =
        typeof req.sequenceFilterData === 'string'
          ? req.sequenceFilterData
          : JSON.stringify(req.sequenceFilterData);
    }

    if (req.operationType === 'update') {
      variables.whereField = req.whereField!.trim();
      variables.whereValue = String(req.whereValue);
    }

    if (req.successMessage) {
      variables.successMessage = req.successMessage;
    }
    if (req.failureMessage) {
      variables.failureMessage = req.failureMessage;
    }

    return this._vitalHttpServices.GetData(
      this.buildGraphqlRequest(variables, query),
      this.resolveDeploymentKey(req.dbName)
    );
  }

  parseDynamicMutationResponse(res: any): ParsedDynamicMutation {
    const raw = res?.data?.executeMutation;
    if (raw == null) {
      return { success: false, message: 'Empty response' };
    }
    try {
      const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
      const success = !!(parsed?.success || parsed?.status === 'success');
      return { success, message: parsed?.message, data: parsed?.data };
    } catch {
      return { success: false, message: String(raw) };
    }
  }
}

export type DynamicMutationOperation = 'insert' | 'update';

export interface DynamicMutationRequest {
  operationType: DynamicMutationOperation;
  tableName: string;
  data: Record<string, unknown>;
  whereField?: string;
  whereValue?: string | number;
  uniqueData?: Record<string, unknown>;
  filterData?: Record<string, unknown>;
  sequenceColumnNames?: string[] | string;
  sequenceFilterData?: Record<string, unknown> | string;
  insertQueryKey?: string;
  updateQueryKey?: string;
  successMessage?: string;
  failureMessage?: string;
  dbName?: string;
}

export interface ParsedDynamicMutation {
  success: boolean;
  message?: string;
  data?: any;
}
